import { CVFile } from "../interface/CV_types";
import { DownloadButton } from "./DownloadButton";
import { DeleteButton } from "./DeleteButton";


/**
 * This component shows the details of a single file
 * 
 */
export function CVFileContainer({file, project_id}: {file: CVFile, project_id: string}) {
    console.log(file)
    const file_size_to_mb = (file.size / (1024 * 1024)).toFixed(2)

    return (
        <div className="flex flex-row gap-4 justify-between border cv-file-border rounded-md p-4 cv-file-background transition-all duration-300">
            {/* This shows the file details */}
            <div className="flex flex-col gap-2">
                <h2 className="text-lg font-bold">{file.name}</h2>
                <p className="text-sm text-gray-500">{file_size_to_mb} MB</p>
            </div>

            <div className="flex justify-end gap-2">
                <DownloadButton file={file} project_id={project_id} />
                <DeleteButton file={file} project_id={project_id} />
            </div>
        </div>
    )
}